import type {ReactElement} from 'react';
import {useState} from 'react';
import {Button, Size, Type} from '@Components/button';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import type {ChangeStyleDropdownProps} from '@Components/ai-chat-window/components/change-style-dropdown/change-style-dropdown.types';
import {CHANGE_STYLE_DROPDOWN_MODAL_PANEL_ID} from '@Components/ai-chat-window/components/change-style-dropdown/change-style-dropdown.types';
import {ThemeGrid} from '@Components/ai-chat-window/components/change-style-dropdown/components/theme-grid/theme-grid';
import {ChangeStylePopup} from '@Components/ai-chat-window/components/change-style-dropdown/components/change-style-popup/change-style-popup';
import {useChangeStyleThemeSelect} from '@Components/ai-chat-window/hooks/useChangeStyleThemeSelect';
import styles from './change-style-dropdown.module.scss';

export function ChangeStyleDropdown(props: ChangeStyleDropdownProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  const {onThemeSelect} = useChangeStyleThemeSelect({
    chatId: props.chatId,
    onGenerate: props.onGenerate,
    imageHashedId: props.imageHashedId,
    imageWidth: props.imageWidth,
    imageHeight: props.imageHeight,
  });

  const handleOpen = (): void => {
    setIsOpen(true);
  };

  const handleClose = (): void => {
    setIsOpen(false);
  };

  const getChangeStyleButton = (): ReactElement => {
    return (
      <Button
        customClasses={`radius-8 _full-height ${styles.changeStyleButton}`}
        type={Type.SECONDARY}
        size={Size.XSMALL}
        text={window.i18next.t('pmwjs_change_style')}
        icon={'icon-repeat'}
        disabled={!props.canWrite}
        isActive={isOpen}
      />
    );
  };

  return (
    <Dropdown
        open={isOpen}
        onOpen={handleOpen}
        onClose={handleClose}
        isResumable
        isSmallScreenModalBottomSheet={false}
        doCloseOnInnerClick
        showModalForSmallScreen
        modalTitle={window.i18next.t('pmwjs_ai_chat_change_style_heading')}
        modalContent={<ThemeGrid onThemeSelect={onThemeSelect} />}
        modalClassName={styles.modalContent}
        panelIdForModal={CHANGE_STYLE_DROPDOWN_MODAL_PANEL_ID}
        alignment={ALIGNMENT_TYPE.RIGHT_END}
        popupClassName={styles.popup}
        className={styles.positionUnset}
        selector={getChangeStyleButton()}
        popup={<ChangeStylePopup onThemeSelect={onThemeSelect} />}
        popupOffset={8}
    />
  );
}
